import React from 'react';
import {Outlet, UIMatch, useMatches} from 'react-router-dom';
import { PageTitleKeys } from '../config/routeConstants';
import { usePageTitle } from '../hooks/usePageTitle';
import { usePageDescription } from '../hooks/usePageDescription';

const PublicLayout = () => {
    const matches = useMatches() as UIMatch<unknown, { titleKey?: PageTitleKeys }>[];
    const lastMatch = matches[matches.length - 1];
    const titleKey = lastMatch?.handle?.titleKey || PageTitleKeys.Default;

    usePageTitle(titleKey);
    usePageDescription(titleKey);

    return (
        <>
            <Outlet/>
        </>
    );
};

export default PublicLayout;
